import { Route, Navigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Spin, Flex } from 'antd';
import Cookies from 'js-cookie';
import isCan from '../../../../components/isCan';
import perms from '../../../../config/perms';
import { notification } from 'antd';
import { useNavigate } from 'react-router-dom';
export const UserContext = React.createContext();
export const GlobalContainerContext = React.createContext();

export const PrivateRoute = ({ children, mainpath }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const navigate = useNavigate()
  const [isPermitted, setIsPermitted] = useState(false);
  const location = useLocation();
  const isLoginPage = location.pathname.includes('/login');
  const isAccessDeneidPage = location.pathname.includes('/access/deneid');
  const [globalUser, setGlobalUser] = useState({})
  const [lastUrl, setLastUrl] = useState(location.pathname)
  const [globalContainer, setGlobalContainer] = useState(() => {
    const savedContainer = localStorage.getItem('globalContainer')
    return savedContainer ? JSON.parse(savedContainer) : []
  })

  useEffect(() => {
    if (globalContainer && globalContainer.length > 0) {
      localStorage.setItem('globalContainer', JSON.stringify(globalContainer))
    }
  }, [globalContainer])

  useState(() => {
    setLastUrl(location.pathname)
  }, [location.pathname])

  useEffect(() => {
    const fetchData = async () => {
      const permitted = await isCan(perms[mainpath].permissions)
      if((permitted ? false : true) && isAuthenticated){
        navigate("/access/denied")
      }
    }
    fetchData()
  },[isAuthenticated, mainpath])
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(process.env.REACT_APP_API_URL+'/auth/session/check');
        if (response.data.authenticated === true) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setIsAuthenticated(false);
      }
    };

    fetchData();
  }, [isAuthenticated]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(process.env.REACT_APP_API_URL+'/auth/get/user');
        setGlobalUser(response.data)
      } catch (error) {
        console.error('Error fetching data:', error);

      }
    };

    fetchData();
  }, [isAuthenticated]);

  if (isAuthenticated === null && !isLoginPage) {
    return <></>;
  }

  if (isAuthenticated === false && !isLoginPage) {
    localStorage.setItem('lasturl', lastUrl);
    window.location.href = process.env.REACT_APP_FRONT_URL+'/#/login?app='+process.env.REACT_APP_APP_KEY;
    return false
  }
  if(localStorage.getItem('lasturl')){
    const lasturl = localStorage.getItem('lasturl');
    localStorage.removeItem('lasturl')
    return <Navigate to={lasturl} />;
  }
  if(isAuthenticated === true && isLoginPage){
    return <Navigate to="/" />;
  }
  if(isAuthenticated === false && isLoginPage){
    return (
      <GlobalContainerContext.Provider value={{ globalContainer, setGlobalContainer }}>
        <UserContext.Provider value={globalUser}>{children}</UserContext.Provider>
      </GlobalContainerContext.Provider>
    );
  }
  if(isAuthenticated === true && !isLoginPage){
    return (
      <GlobalContainerContext.Provider value={{ globalContainer, setGlobalContainer }}>
        <UserContext.Provider value={globalUser}>{children}</UserContext.Provider>
      </GlobalContainerContext.Provider>
    );
  }
};

export default PrivateRoute;
